import { createRoot } from "react-dom/client";

import "@/styles/base.css";
import "@/styles/app.css";

import { Provider } from "react-redux";

import App from "@/App";
import store from "@/app/store";
import * as serviceWorker from "@/serviceWorker";
import { setupBraze } from "@/utils/analytics/braze/utils";

const root = createRoot(document.getElementById("root"));

// Initialize Braze SDK
setupBraze();

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
